import { render, staticRenderFns } from "./ErrorNotFoundNotHeader.vue?vue&type=template&id=302e6cd8&scoped=true&"
import script from "./ErrorNotFoundNotHeader.vue?vue&type=script&lang=ts&"
export * from "./ErrorNotFoundNotHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorNotFoundNotHeader.vue?vue&type=style&index=0&id=302e6cd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302e6cd8",
  null
  
)

export default component.exports